import { render, staticRenderFns } from "./cumprimentoobrigacao.vue?vue&type=template&id=619d0b29&scoped=true&"
import script from "./cumprimentoobrigacao.vue?vue&type=script&lang=js&"
export * from "./cumprimentoobrigacao.vue?vue&type=script&lang=js&"
import style0 from "./cumprimentoobrigacao.vue?vue&type=style&index=0&id=619d0b29&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "619d0b29",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VCard,VCardText,VCardTitle,VIcon,VList,VListItem,VListItemTitle,VMenu})
